export const validateEmail = (val) => {
  if (val === "") {
    return "Email is required"
  }

  const re = new RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
  if (!re.test(val)) {
    return "Input must be a valid email"
  }
}

export const requiredValidator = (val) => {
  if (val === "") {
    return "This field is required!"
  }
}